import { useCanonicalStatisticsTrades } from './useCanonicalStatisticsTrades';
import type { TenantId } from '../config/runtime/types';
import { currentRuntime } from '../config/runtime';

/**
 * The dashboard consumes the SAME canonical filtered trade collection as every
 * other statistics surface (Calendar, Journal, Trend, WinVsLoss, Trades page
 * totals, and every performance widget). Demo replacement is handled by the
 * canonical hook, so the dashboard never retains a stale repository copy.
 */
export function useDashboardTrades(tenantId: TenantId = currentRuntime.tenant.id) {
  return useCanonicalStatisticsTrades(tenantId);
}
